<script>
import CommonConstants from '../../../common/Constants';
import config from '../../../common/genericPanelConf';
import Utils from '../../../common/Utils';
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import Service from '@/services/planning';
import CommonService from '@/services/common';
import Dropdown from 'primevue/dropdown';
import Card from 'primevue/card';
import InputNumber from 'primevue/inputnumber';
import ResponsiveButton from '../../../components/generic/ResponsiveButton.vue'
import GenericCustomMasterDataAutocompleteV2 from '../../../components/generic/GenericCustomMasterDataAutocompleteV2.vue'
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import TreeTable from 'primevue/treetable';
import Column from 'primevue/column';


export default{
  setup: () => ({ v$: useVuelidate() }),
  components: {
    ResponsiveButton, GenericCustomMasterDataAutocompleteV2
  },
  data(){
    return {
        monthDate: Utils.setFirstDayOfMonth(Utils.formatDatePlusMonths(new Date(), -1)),
        tollingPriceHeader: {},
        tollingPriceCrude: [],
        crudeTollingPrice: null,
        selectedCrude: {},
        editingRows: [],
        idPlanningTollingPriceHeader: null,
        showAddDialog: false,
        addItem: {
            referenceDate: this.monthDate,
            idCrudeRegistryProduct: null,
            crudeVolumeBBL: 0,
            conversionFactor: 0,
            feeCrude: 0,
            crudeDifferential: 0,
            dieselBalancingTrade: 0
        },
        weightedAvgTollingPrice: {},
        weightedColums: [],
        expandedRowGroups: null,
        tollingPriceClone:{
            monthDate: this.monthDate,
            referenceMonth: Utils.setFirstDayOfMonth(Utils.formatDatePlusMonths(new Date(), -2)),
        },
        showCloneDialog: false
    }
  },
  validations(){
    return {
        addItem: {
            idCrudeRegistryProduct: {required},
            crudeVolumeBBL: {required},
            conversionFactor: {required},
            feeCrude: {required},
            crudeDifferential: {required},
            dieselBalancingTrade: {required} 
        } 
    }
  },
  watch:{
    'monthDate'(){
        this.getTollingPrice();
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    }
  },
  created(){

  },
  mounted(){
    this.$store.dispatch('security/setNavbarTitle', 'tollingPrice.page_title');
  },
  methods: {
    getTollingPrice(){

        this.tollingPriceCrude = [];

        let body = {
            monthDate: Utils.formatDateForAPI(this.monthDate),
        }

        this.$store.dispatch("generic/setLoading", true);
        Service.getTrueUpTollingPriceHeaderByMonth(body, response => {
            this.$store.dispatch("generic/setLoading", false);
            if(response.success && response.data != null){
               this.tollingPriceCrude = response.data;

               for(let i = 0; i < this.tollingPriceCrude.length; i++){
                    let item = this.tollingPriceCrude[i];

                    item.volumeLessPerc = item.volumeLessPerc * 100;

                    item.planningTrueUpTollingPriceDetails.push({
                        id: 0,
                        idPlanningTollingPriceHeader: item.id,
                        productPool: "Total",
                        quantityMT: null,
                        conversionFactor: 0,
                        volumeBBL: item.totalVolumeDetailsBBL
                    });

                    item.planningTrueUpTollingPriceDetails.push({
                        id: -1,
                        idPlanningTollingPriceHeader: item.id,
                        productPool: "Delta",
                        quantityMT: null,
                        conversionFactor: 0,
                        volumeBBL: item.deltaDetails
                    });
               }
               body = {
                referenceDate: Utils.formatDateForAPI(this.monthDate),
                }

                Service.weightedAverageTrueUpTollingPrice(body, response => {
                    if(response.success && response.data != null){
                    this.weightedColums = [];
                        let weightedAvergateTollingPrice= response.data.weightedAvergateTollingPrice;
                        for(let key in weightedAvergateTollingPrice){
                            for(let i = 0; i < weightedAvergateTollingPrice[key].length; i++){
                                this.weightedColums.push(weightedAvergateTollingPrice[key][i]);
                            }
                        }
                    }
                });        
            }else{                
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});           
            }
        });       
    },
    /*getTollingPrice(){
        this.$store.dispatch("generic/setLoading", true);
        Service.getTrueUpTollingPriceHeaderById(this.idPlanningTollingPriceHeader, (response) => {
            this.$store.dispatch("generic/setLoading", false);
            if (response.success) {
                this.selectedCrude = response.data;
                this.getTollingPriceDetails();
            } else {
                this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
            }
        })
    },*/
    onTollingPriceDetailSave(data){

        let sameData = Object.entries(data.data).every(([key, value]) => value === data.newData[key])
        
        if(!sameData){       
            this.$store.dispatch("generic/setLoading", true);
            Service.updatetTrueUpTollingPriceDetail(data.newData, (response) => {
                this.$store.dispatch("generic/setLoading", false);
                if (response.success) {
                    this.getTollingPrice();
                    this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                } else {
                    this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        }
    },
    onSaveTollingPriceHeader(item){
        let body = {
            id: item.id,
            crudeVolumeBBL: item.crudeVolumeBBL,
            conversionFactor: item.conversionFactor,
            feeCrude: item.feeCrude,
            crudeDifferential: item.crudeDifferential,
            dieselBalancingTrade: item.dieselBalancingTrade
        }
        
        this.$store.dispatch("generic/setLoading", true);

        Service.updateTrueUpTollingPriceHeaderById(body, response => {
            this.$store.dispatch("generic/setLoading", false);
            if(response.success){
                this.getTollingPrice();                          
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
            }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
        });      
    },
    onSaveNewItem(valid){
        this.addItem.referenceDate = Utils.formatDateForAPI(Utils.dateToCurrentTimeZone(this.monthDate));

        this.$store.dispatch("generic/setLoading", true);
        Service.addTrueUpTollingPriceHeader(this.addItem, response => {
            this.showAddDialog = false;
            this.$store.dispatch("generic/setLoading", false);
            if(response.success){               
                this.getTollingPrice();
                this.addItem = {
                    referenceDate: this.monthDate,
                    idCrudeRegistryProduct: null,
                    crudeVolumeBBL: 0,
                    conversionFactor: 0,
                    feeCrude: 0,
                    crudeDifferential: 0,
                    dieselBalancingTrade: 0
                },
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
            }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
        });
    },
    onExportExcel(){
        let body = {
                monthDate: Utils.formatDateForAPI(this.monthDate),
            }

        this.$store.dispatch("generic/setLoading", true);
        let fileNameWithExtension = "TollingPrice.xlsx";
        Service.exportTrueUpTollingPrice(body, ({success, data, message}) => {
            this.$store.dispatch("generic/setLoading", false);
    
            if(success){
                var fileURL = window.URL.createObjectURL(new Blob([data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', fileNameWithExtension);
                document.body.appendChild(fileLink);
            
                fileLink.click();
            } else{
                this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
            }
        });
    },
    onDeleteDetail(data){
        this.$store.dispatch("generic/setLoading", false);
        Service.deleteTollingPriceDetail(data.id, response => {
            this.$store.dispatch("generic/setLoading", false);
            if(response.success){
                this.getTollingPrice();                          
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
            }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
        });    
    },
    buttonHidden(data){
        switch(data.productPool){
            case 'Delta':
            case 'Total': return true;

            default: return false;
        }
    },
    cloneTollingPrice(){
        let body = {
            monthDate: Utils.formatDateForAPI(this.monthDate),
            referenceMonth: Utils.formatDateForAPI(this.tollingPriceClone.referenceMonth),
        }

        this.$confirm.require({
            message: this.$t('tollingPrice.clone_tolling_price'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.$t('yes'),
            rejectLabel: this.$t('no'),
            accept: () => {                  
                this.$store.dispatch("generic/setLoading", true);

                Service.cloneTrueUpTollingPriceHeader(body, response => {
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){
                        this.showCloneDialog = false;
                        this.getTollingPrice();                          
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                });    
            },
            reject: () => {
                this.$confirm.close();
            }
        });       
    },
  }
}

</script>

<template>
    <main>
        <Dialog v-model:visible="showCloneDialog" modal :style="{width: '15vw'}">
            <div class="field">
                <label for="ReferenceMonth">{{ $t('tollingPrice.monthDateToClone') }}</label>
                <Calendar
                    :class="{'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    view="month" dateFormat="mm/yy"
                    :showTime="false"
                    v-model="this.tollingPriceClone.referenceMonth"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            </div>

            <template #footer>
                <ResponsiveButton :label="$t('btn.save')" icon="pi pi-save" class="my-2 p-button-outlined" @click="cloneTollingPrice()" />
            </template>
        </Dialog>
        <Dialog v-model:visible="showAddDialog" modal :style="{width: '25vw'}">
            <div class="field">
                <label for="ReferenceDate">{{ $t('tollingPrice.monthDate') }}</label>
                <Calendar
                    :class="{'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    view="month" dateFormat="mm/yy"
                    :showTime="false"
                    v-model="this.monthDate"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" disabled />
            </div>

            <div class="field">
                <label for="idCrudeRegistryProduct">{{ $t('tollingPrice.crudeTolling') }}</label>
                <GenericCustomMasterDataAutocompleteV2
                class="w-full p-inputtext-sm mt-1"
                v-model="addItem.idCrudeRegistryProduct"
                api="masterdata/product-tolling-mapping-combo?isCrude=true" 
                name="masterdata-product-tolling-mapping-combo" />

                <div v-if="(v$.addItem.idCrudeRegistryProduct.$invalid) || v$.addItem.idCrudeRegistryProduct.$pending.$response">
                    <small class="p-error" v-for="error in v$.addItem.idCrudeRegistryProduct.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>

            <div class="field">
                <label for="crudeVolumeBBL">{{$t('tollingPrice.crudeVolumeBBL')}}</label>
                <InputNumber class="w-full" v-model="this.addItem.crudeVolumeBBL" :min-fraction-digits="0" />

                <div v-if="(v$.addItem.crudeVolumeBBL.$invalid) || v$.addItem.crudeVolumeBBL.$pending.$response">
                    <small class="p-error" v-for="error in v$.addItem.crudeVolumeBBL.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>

            <div class="field">
                <label for="conversionFactor">{{$t('tollingPrice.conversionFactor')}}</label>
                <InputNumber class="w-full" v-model="this.addItem.conversionFactor" :min-fraction-digits="10" />

                <div v-if="(v$.addItem.conversionFactor.$invalid) || v$.addItem.conversionFactor.$pending.$response">
                    <small class="p-error" v-for="error in v$.addItem.conversionFactor.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>

            <div class="field">
                <label for="feeCrude">{{$t('tollingPrice.feeCrude')}}</label>
                <InputNumber class="w-full" v-model="this.addItem.feeCrude" :min-fraction-digits="3" />

                <div v-if="(v$.addItem.feeCrude.$invalid) || v$.addItem.feeCrude.$pending.$response">
                    <small class="p-error" v-for="error in v$.addItem.feeCrude.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>

            <div class="field">
                <label for="crudeDifferential">{{$t('tollingPrice.crudeDifferential')}}</label>
                <InputNumber class="w-full" v-model="this.addItem.crudeDifferential" :min-fraction-digits="3" />

                <div v-if="(v$.addItem.crudeDifferential.$invalid) || v$.addItem.crudeDifferential.$pending.$response">
                    <small class="p-error" v-for="error in v$.addItem.crudeDifferential.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>

            <div class="field">
                <label for="dieselBalancingTrade">{{$t('tollingPrice.dieselBalancingTrade')}}</label>
                <InputNumber class="w-full" v-model="this.addItem.dieselBalancingTrade" :min-fraction-digits="3" />

                <div v-if="(v$.addItem.dieselBalancingTrade.$invalid) || v$.addItem.dieselBalancingTrade.$pending.$response">
                    <small class="p-error" v-for="error in v$.addItem.dieselBalancingTrade.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>

            <template #footer>
                <ResponsiveButton :label="$t('btn.save')" icon="pi pi-save" class="my-2 p-button-outlined" @click="onSaveNewItem((!v$.$invalid))" />
            </template>

        </Dialog>
        <div class="m-5">
            <div class="grid">
                <div class="col-2">
                    <label for="monthDate">{{$t('PricedQuantitiesBalance.monthStartDate')}}</label>
                    <Calendar
                    :class="{'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    view="month" dateFormat="mm/yy"
                    :showTime="false"
                    v-model="monthDate"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                </div>

                <!--<div class="col-2 lg:col-2">
                    <label for="version">{{$t('tollingPrice.crudeTolling')}}</label>
                    <Dropdown v-model="idPlanningTollingPriceHeader" :options="tollingPriceCrude" class="w-full" optionLabel="label" optionValue="value" />
                </div>-->

                <div class="col-12 lg:col-4 mx-3 my-3">
                    <ResponsiveButton :label="$t('btn.load')" icon="pi pi-replay" class="m-2 p-button-sm" @click="getTollingPrice()"/>
                    <ResponsiveButton :label="$t('btn.export')" icon="pi pi-file-excel" class="m-2 p-button-sm p-button-outlined" @click="onExportExcel()" />
                    <ResponsiveButton :label="$t('btn.add')" class="m-2 p-button-sm" icon="pi pi-plus" @click="showAddDialog = true" autofocus /> 
                    <ResponsiveButton :label="$t('btn.clone')" class="m-2 p-button-sm p-button-outlined" icon="pi pi-clone" @click="showCloneDialog = true" autofocus /> 
                </div>                
            </div>
            <TabView>
                <TabPanel :header="item.crudeDescription" v-for="item in tollingPriceCrude" :key="item.id">                                
                    <Card style="border: 1px solid var(--primary-color);">
                        <template #content>
                            <div class="grid" >
                                <div class="col-12 lg:col-4">
                                    <label style="color: var(--primary-color);" for="conversionFactor"> {{$t('tollingPrice.conversionFactor')}} </label>
                                    <InputNumber class="w-full my-2" v-model="item.conversionFactor" :minFractionDigits="6" />  
                                </div>  
                                
                                <div class="col-12 lg:col-4">
                                    <label style="color: var(--primary-color);" for="volumeLessPerc"> {{$t('tollingPrice.volumeLessPerc')}} </label>
                                    <InputNumber disabled readonly class="w-full my-2" v-model="item.volumeLessPerc" mode="decimal" suffix="%" :minFractionDigits="2" />
                                </div> 
                                
                                <div class="col-12 lg:col-4">
                                    <label style="color: var(--primary-color);" for="isabPaymentForCrude"> {{$t('tollingPrice.isabPaymentForCrude')}} </label>
                                    <InputNumber disabled readonly class="w-full my-2" v-model="item.isabPaymentForCrude" :minFractionDigits="0" >
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatInteger(data[field]) }}</span>
                                        </template>
                                    </InputNumber> 
                                </div> 

                                <div class="col-12 lg:col-4">
                                    <label style="color: var(--primary-color);" for="crudeVolumeBBL"> {{$t('tollingPrice.crudeVolumeBBL')}} </label>
                                    <InputNumber class="w-full my-2" v-model="item.crudeVolumeBBL" :minFractionDigits="0" />
                                </div> 

                                <div class="col-12 lg:col-4">
                                    <label style="color: var(--primary-color);" for="productPrice"> {{$t('tollingPrice.productPrice')}} </label>
                                    <InputNumber disabled readonly class="w-full my-2" v-model="item.productPrice" :minFractionDigits="3" />
                                </div> 
                                
                                <div class="col-12 lg:col-4">
                                    <label style="color: var(--primary-color);" for="trafiguraPaymentForProducts"> {{$t('tollingPrice.trafiguraPaymentForProducts')}} </label>
                                    <InputNumber disabled readonly class="w-full my-2" v-model="item.trafiguraPaymentForProducts" :minFractionDigits="0" />
                                </div>

                                <div class="col-12 lg:col-4">
                                    <label style="color: var(--primary-color);" for="crudeWeightMT"> {{$t('tollingPrice.crudeWeightMT')}} </label>
                                    <InputNumber disabled readonly class="w-full my-2" v-model="item.crudeWeightMT" :minFractionDigits="3" />
                                </div>

                                <div class="col-12 lg:col-4">
                                    <label style="color: var(--primary-color);" for="productPremium"> {{$t('tollingPrice.productPremium')}} </label>
                                    <InputNumber disabled readonly class="w-full my-2" v-model="item.productPremium" :minFractionDigits="3" />
                                </div>

                                <div class="col-12 lg:col-4">
                                    <hr style="background-color: black;">
                                    <label style="color: black" for="monthlyFee"> {{$t('tollingPrice.monthlyFee')}} </label>
                                    <InputNumber disabled readonly class="w-full my-2" v-model="item.monthlyFee" :minFractionDigits="0" />
                                </div>

                                <div class="col-12 lg:col-4">
                                    <label style="color: var(--primary-color);" for="feeCrude"> {{$t('tollingPrice.feeCrude')}} </label>
                                    <InputNumber class="w-full my-2" v-model="item.feeCrude" :minFractionDigits="3" />
                                </div>
                                
                                <div class="col-12 lg:col-4">
                                    <label style="color: var(--primary-color);" for="totalValueOfTollFee"> {{$t('tollingPrice.totalValueOfTollFee')}} </label>
                                    <InputNumber disabled readonly class="w-full my-2" v-model="item.feeCrude" :totalValueOfTollFee="3" />
                                </div>
                            </div>
                            
                            <div class="grid my-4">
                                <div class="col-12 lg:col-4">
                                    <label style="color: var(--primary-color);" for="crudePrice"> {{$t('tollingPrice.crudePriceAvgMonth')}} </label>
                                    <InputNumber disabled readonly class="w-full my-2" v-model="item.crudePrice" :minFractionDigits="3" />
                                </div>
                            </div>

                            <div class="grid my-4">
                                <div class="col-12 lg:col-4">
                                    <label style="color: var(--primary-color);" for="crudeDifferential"> {{$t('tollingPrice.crudeDifferential')}} </label>
                                    <InputNumber class="w-full my-2" v-model="item.crudeDifferential" :minFractionDigits="3" />
                                </div>

                                <div class="col-12 lg:col-4">
                                    <label style="color: var(--primary-color);" for="dieselBalancingTrade"> {{$t('tollingPrice.dieselBalancingTrade')}} </label>
                                    <InputNumber class="w-full my-2" v-model="item.dieselBalancingTrade" :minFractionDigits="3" />
                                </div>
                            </div>     
                            
                            <div class="grid my-4">
                                <div class="col-12 lg:col-4">
                                    <label style="color: var(--primary-color);" for="crudePrice"> {{$t('tollingPrice.crudePrice')}} </label>
                                    <InputNumber disabled readonly class="w-full my-2" v-model="item.crudePrice" :minFractionDigits="3" />
                                </div>

                                <div class="col-12 lg:col-4">
                                    <label style="color: var(--primary-color);" for="dieselBalancingTradePrice"> {{$t('tollingPrice.dieselBalancingTradePrice')}} </label>
                                    <InputNumber disabled readonly class="w-full my-2" v-model="item.dieselBalancingTradePrice" :minFractionDigits="3" />
                                </div>
                            </div>
                            <div class="grid my-4">
                                <div class="col-12 lg:col-4">
                                <ResponsiveButton :label="$t('btn.save')" icon="pi pi-save" class="m-2 p-button-sm p-button-success" 
                                @click="onSaveTollingPriceHeader(item)" v-if="uiPermissions('TollingPriceHeaderSaveButton').isEnabled"/>
                                </div>
                            </div>
                        </template>
                    </Card>             
                        <DataTable v-if="item.planningTrueUpTollingPriceDetails.length > 0" :value="item.planningTrueUpTollingPriceDetails" scrollable showGridlines stripedRows class="my-5"
                            v-model:editingRows="editingRows" editMode="row" dataKey="id" @row-edit-save="onTollingPriceDetailSave" tableStyle="min-width: 85rem" scrollHeight="400px">

                            <Column :rowEditor="true" style="width: 10%; min-width: 8rem" v-if="uiPermissions('TollingPriceDetailEditButton').isEnabled" />

                            <Column frozen class="button-column over-z" :exportable="false" :reorderableColumn="false">
                                <template #body="slotProps">
                                    <Button v-tooltip="$t('btn.delete')" icon="pi pi-trash" class="p-button-rounded p-button-warning" 
                                    @click="onDeleteDetail(slotProps.data)" v-if="!uiPermissions('TollingPriceDetailDeleteButton').isHidden && !buttonHidden(slotProps.data)" />
                                </template>
                            </Column>

                            <Column field="productPool" :header="$t('tollingPrice.productPool')" style="min-width: 100px" >
                                <template #body = "{data, field}">
                                    <span v-if="buttonHidden(data)" style="font-weight: bold;">{{ data[field] }}</span>
                                    <span v-else>{{ data[field] }}</span>
                                </template>
                            </Column>

                            <Column field="quantityMT" :header="$t('tollingPrice.quantityMT')" style="min-width: 100px">
                                <template #body = "{data, field}">
                                    <span>{{ utils.formatInteger(data[field]) }}</span>
                                </template>
                                <template #editor="{ data, field }">
                                    <InputNumber v-model="data[field]" :minFractionDigits="0" v-if="!buttonHidden(data)" />
                                </template>
                            </Column>

                            <Column field="conversionFactor" :header="$t('tollingPrice.conversionFactor')" style="min-width: 100px">
                                <template #body = "{data, field}">
                                    <span v-if="buttonHidden(data)" style="font-weight: bold;">{{ utils.formatDecimal(data[field], 6) }}</span>
                                    <span v-else>{{ utils.formatDecimal(data[field], 6) }}</span>
                                </template>
                                <template #editor="{ data, field }">
                                    <InputNumber v-model="data[field]" :minFractionDigits="6"  v-if="!buttonHidden(data)"/>
                                </template>
                            </Column>

                            <Column field="volumeBBL" :header="$t('tollingPrice.volumeBBL')" style="min-width: 100px">
                                <template #body = "{data, field}">
                                    <span v-if="buttonHidden(data)" style="font-weight: bold;">{{ utils.formatInteger(data[field]) }}</span>
                                    <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                                </template>   
                                <template #editor="{ data, field }">
                                    <InputNumber v-model="data[field]" :minFractionDigits="3"  v-if="!buttonHidden(data)"/>
                                </template>          
                            </Column>
                        </DataTable>
                    </TabPanel>
                        <TabPanel header="Weighted AVG Price" v-if="tollingPriceCrude.length > 1">
                            <DataTable v-model:expandedRowGroups="expandedRowGroups" :value="weightedColums" tableStyle="min-width: 55rem"
                            expandableRowGroups rowGroupMode="subheader" groupRowsBy="product">
                                <template #groupheader = "slotProps">
                                    <p style="min-width: 100px; font-weight: bold;">{{ slotProps.data.product }}</p>
                                </template>
                                    <Column style="min-width: 100px;" field="description" header="Product"></Column>
                                    <Column style="min-width: 100px;" field="volumeBBl" header="BBL">
                                        <template #body = "{data, field}">                                        
                                            <span>{{ utils.formatDecimal(data[field], 3) }}</span>
                                        </template> 
                                    </Column>
                                    <Column style="min-width: 100px;" field="price" header="Price">
                                        <template #body = "{data, field}">                                        
                                            <span>{{ utils.formatDecimal(data[field], 3) }}</span>
                                        </template> 
                                    </Column>
                            </DataTable>
                        </TabPanel>
                </TabView>           
            </div>
    </main>
</template>
